import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center" }
const _hoisted_9 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_10 = { class: "custom-alert-title flex flex-col" }
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { style: {"overflow-y":"auto","height":"calc(100vh - 227px)"} }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pr-7" }
const _hoisted_16 = { class: "min-w-[122px]" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "bg-red-400 border-2 border-gray-900 rounded-md"
}
const _hoisted_19 = {
  key: 1,
  class: "bg-green-400 border-2 border-gray-900 rounded-md"
}
const _hoisted_20 = {
  key: 2,
  class: "bg-purple-400 border-2 border-gray-900 rounded-md"
}
const _hoisted_21 = {
  key: 3,
  class: "bg-yellow-400 border-2 border-gray-900 rounded-md"
}
const _hoisted_22 = {
  key: 4,
  class: "bg-sky-400 border-2 border-gray-900 rounded-md"
}
const _hoisted_23 = { class: "alert-table hidden md:block w-full" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "flex w-full justify-end mt-4" }
const _hoisted_33 = { class: "hidden md:block mr-3" }
const _hoisted_34 = { class: "md:hidden" }
const _hoisted_35 = { class: "flex-col w-full px-2 justify-center items-center" }
const _hoisted_36 = { class: "flex flex-col md:flex-row" }
const _hoisted_37 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_38 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_39 = { class: "flex w-full items-center justify-center" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "el-upload-list__item-actions" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "dialog-footer flex items-center" }
const _hoisted_46 = { class: "flex gap-2 ml-auto" }
const _hoisted_47 = { class: "flex justify-center items-center" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "flex-col w-full px-2" }
const _hoisted_50 = { class: "flex flex-col" }
const _hoisted_51 = { class: "text-gray-400 text-sm" }
const _hoisted_52 = { class: "dialog-footer" }
const _hoisted_53 = { class: "felx flex-col h-full p-5" }
const _hoisted_54 = { class: "flex items-center justify-center h-[72px]" }
const _hoisted_55 = { class: "action-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_MaterialSelect = _resolveComponent("MaterialSelect")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid gap-4", [
                                _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-7' : (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead ? 'md:grid-cols-6' : 'md:grid-cols-5'),
                            ]])
                    }, [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "組織"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.searchForm.organization_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                            "is-search": true,
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "部門"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.department_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                            placeholder: "部門を選択",
                            onOrganizationIdChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                      ]),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "カテゴリ"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CategorySelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.category_id,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                            placeholder: "カテゴリを選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "アイテム名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AutoCompleteInput, {
                            modelValue: _ctx.searchForm.material_name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                            placeholder: "アイテム名を入力",
                            "storage-key": "material-name-history",
                            "max-history-items": 15,
                            ref: "materialNameInput"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "ステータス"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.searchForm.status,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.status) = $event)),
                            placeholder: "ステータスを選択"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "すべて",
                                value: _ctx.ALL
                              }, null, 8, ["value"]),
                              _createVNode(_component_el_option, {
                                label: "未対応",
                                value: 1
                              }),
                              _createVNode(_component_el_option, {
                                label: "補充依頼中",
                                value: 2
                              }),
                              _createVNode(_component_el_option, {
                                label: "発注済み",
                                value: 3
                              }),
                              _createVNode(_component_el_option, {
                                label: "廃棄予定",
                                value: 4
                              }),
                              _createVNode(_component_el_option, {
                                label: "対応完了",
                                value: 5
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "アラート"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.checkResult,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkResult) = $event)),
                            multiple: "",
                            placeholder: "アラートを選択してください",
                            "collapse-tags": "",
                            "collapse-tags-tooltip": ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkResults, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "primary",
                          onClick: _ctx.handleSearchButton
                        }, {
                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "組織"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                "is-search": true,
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                          ]),
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "部門"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DepartmentSelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.department_id,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                                placeholder: "部門を選択",
                                onOrganizationIdChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                          ]),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "カテゴリ"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CategorySelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.category_id,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                                placeholder: "カテゴリを選択"
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "アイテム名"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AutoCompleteInput, {
                                modelValue: _ctx.searchForm.material_name,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                                placeholder: "アイテム名を入力",
                                "storage-key": "material-name-history",
                                "max-history-items": 15,
                                ref: "materialNameInput"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "ステータス"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.searchForm.status,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchForm.status) = $event)),
                                placeholder: "ステータスを選択"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "すべて",
                                    value: _ctx.ALL
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_el_option, {
                                    label: "未対応",
                                    value: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "補充依頼中",
                                    value: 2
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "発注済み",
                                    value: 3
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "廃棄予定",
                                    value: 4
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "対応完了",
                                    value: 5
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "アラート"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.checkResult,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkResult) = $event)),
                                  multiple: "",
                                  placeholder: "アラートを選択してください",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkResults, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "primary",
                                onClick: _ctx.handleSearchButton,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  class: "custom-alert-icon-btn md:hidden",
                  type: "primary",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[47] || (_cache[47] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[48] || (_cache[48] = _createElementVNode("span", null, "アラート（在庫数　品名　有効期間）", -1)),
                _createElementVNode("span", _hoisted_11, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    key: item.id,
                    style: _normalizeStyle([{"border":"1px solid #d1d5db","border-radius":"0px"}, { backgroundColor: new Date(item.expiration_date) < new Date() ? '#f3f3c1' : '' }]),
                    onClick: ($event: any) => (_ctx.handleEditButton(item, true))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", {
                          class: "material-symbols-outlined cursor-pointer absolute top-0 right-1 text-gray-600 z-10",
                          style: {"font-size":"24px"},
                          onClick: _withModifiers(($event: any) => (_ctx.openNotificationDialog(item)), ["stop","prevent"])
                        }, " mail ", 8, _hoisted_14),
                        _createVNode(_component_el_row, {
                          align: "middle",
                          class: "relative z-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 8,
                              align: "middle"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-5xl", { 'text-red-500': item.check_result6 === 2 }])
                                }, _toDisplayString(item.quantity), 3)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, {
                              span: 15,
                              class: "ml-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(item.material_name), 1),
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["text-xl font-bold", { 'text-red-500': new Date(item.expiration_date) < new Date() }])
                                      }, _toDisplayString(_ctx.moment(item.expiration_date).format('YYYY-MM-DD')), 3),
                                      _createElementVNode("div", null, _toDisplayString(_ctx.getAlert(item).join('・')), 1)
                                    ]),
                                    _createElementVNode("div", {
                                      class: "flex-grow ml-2 text-center",
                                      onClick: _withModifiers(($event: any) => (_ctx.editStatus(item)), ["stop"])
                                    }, [
                                      (item.status === 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "未対応"))
                                        : _createCommentVNode("", true),
                                      (item.status === 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "補充依頼中"))
                                        : _createCommentVNode("", true),
                                      (item.status === 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "発注済み"))
                                        : _createCommentVNode("", true),
                                      (item.status === 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, "廃棄予定"))
                                        : _createCommentVNode("", true),
                                      (item.status === 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "対応完了"))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_17)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["style", "onClick"]))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.mTableData,
                height: "calc(100vh - 260px)",
                "row-class-name": _ctx.tableRowClassName
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "　",
                    width: "80",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "w-12",
                        type: "primary",
                        style: {"background-color":"#c2dbf0"},
                        text: "",
                        bg: "",
                        onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                      }, {
                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                          _createElementVNode("span", null, "詳細", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        prop: "organization_name",
                        label: "組織",
                        width: "200"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    prop: "department_name",
                    label: "部門",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "category_name",
                    label: "カテゴリ",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "material_name",
                    label: "アイテム名",
                    "min-width": "400"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                      _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                      (scope.row.jancode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "user_name",
                    label: "担当者",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "storage_date",
                    label: "保管日",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.moment(row.storage_date).format('YYYY-MM-DD')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "expiration_date",
                    label: "有効期限",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-red-500': new Date(row.expiration_date) < new Date() })
                      }, _toDisplayString(_ctx.moment(row.expiration_date).format('YYYY-MM-DD')), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "quantity",
                    label: "在庫数",
                    width: "66",
                    "header-align": "center",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-red-500': scope.row.check_result6 === 2 })
                      }, _toDisplayString(scope.row.quantity), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "通知",
                    width: "52",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer mt-2",
                        onClick: ($event: any) => (_ctx.openNotificationDialog(scope.row))
                      }, " mail ", 8, _hoisted_25)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "status",
                    label: "ステータス",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "未対応"))
                        : _createCommentVNode("", true),
                      (scope.row.status === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "補充依頼中"))
                        : _createCommentVNode("", true),
                      (scope.row.status === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "発注済み"))
                        : _createCommentVNode("", true),
                      (scope.row.status === 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "廃棄予定"))
                        : _createCommentVNode("", true),
                      (scope.row.status === 5)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "対応完了"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "check_result",
                    label: "アラート",
                    width: "80",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAlert(row), (alert) => {
                        return (_openBlock(), _createElementBlock("div", { key: alert }, _toDisplayString(alert), 1))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "updated_date",
                    label: "更新日時",
                    width: "120",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.moment(row.updated_date).format('YYYY-MM-DD HH:mm:ss')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "52",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer mt-2",
                        onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                      }, " delete ", 8, _hoisted_31)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-class-name"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: "詳細",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          (_ctx.form.add_update === 'update' && _ctx.dialogFormShowDel)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleDeleteButton2(_ctx.form.inventory_id, _ctx.form.sk)))
              }, {
                default: _withCtx(() => _cache[51] || (_cache[51] = [
                  _createTextVNode(" 在庫削除 ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_el_button, {
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialogFormVisible = false))
            }, {
              default: _withCtx(() => _cache[52] || (_cache[52] = [
                _createTextVNode("キャンセル")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => _cache[53] || (_cache[53] = [
                _createTextVNode(" 確認 ")
              ])),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            rules: _ctx.rules,
            ref: "formRef",
            "label-width": "auto"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "組織",
                        prop: "organization_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.form.organization_id,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.organization_id) = $event)),
                            disabled: _ctx.form.add_update === 'update',
                            onOrganizationNameChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.organization_name = $event)),
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "部門",
                        prop: "department_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.form.organization_id,
                            modelValue: _ctx.form.department_id,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.department_id) = $event)),
                            disabled: _ctx.form.add_update === 'update',
                            onDepartmentNameChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.department_name = $event)),
                            placeholder: "部門を選択"
                          }, null, 8, ["organization-id", "modelValue", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "カテゴリ",
                    prop: "category_id",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CategorySelect, {
                        "organization-id": _ctx.form.organization_id,
                        modelValue: _ctx.form.category_id,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.category_id) = $event)),
                        disabled: _ctx.form.add_update === 'update',
                        onCategoryNameChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.category_name = $event)),
                        placeholder: "カテゴリを選択"
                      }, null, 8, ["organization-id", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "アイテム名",
                    prop: "material_code",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MaterialSelect, {
                        "organization-id": _ctx.form.organization_id,
                        modelValue: _ctx.form.material_code,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.material_code) = $event)),
                        disabled: _ctx.form.add_update === 'update',
                        onMaterialNameChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.material_name = $event)),
                        placeholder: "アイテム名を選択"
                      }, null, 8, ["organization-id", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "在庫数",
                    prop: "quantity",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.form.quantity,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.quantity) = $event)),
                        min: 0,
                        max: 999999
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_el_form_item, {
                    label: "保管日",
                    prop: "storage_date",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.storage_date,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.storage_date) = $event)),
                        type: "date",
                        placeholder: "保管日を選択"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "有効期限",
                    prop: "expiration_date",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.expiration_date,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.expiration_date) = $event)),
                        type: "date",
                        placeholder: "有効期限を選択"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "保管場所",
                    prop: "location",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.location,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.location) = $event)),
                        autocomplete: "off",
                        placeholder: "保管場所を入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "ステータス",
                    prop: "status",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.status,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.status) = $event)),
                        placeholder: "ステータスを選択"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "未対応",
                            value: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "補充依頼中",
                            value: 2
                          }),
                          _createVNode(_component_el_option, {
                            label: "発注済み",
                            value: 3
                          }),
                          _createVNode(_component_el_option, {
                            label: "廃棄予定",
                            value: 4
                          }),
                          _createVNode(_component_el_option, {
                            label: "対応完了",
                            value: 5
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "コメント",
                    prop: "comment",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.comment,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.comment) = $event)),
                        autocomplete: "off",
                        placeholder: "コメントを入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "auto-upload": false,
              "on-change": _ctx.handleImageChange,
              multiple: "",
              "on-remove": _ctx.handleRemove,
              limit: 3,
              "on-exceed": _ctx.handleExceed,
              "file-list": _ctx.fileList,
              accept: ".jpg,.jpeg,.png,.webp,.gif"
            }, {
              file: _withCtx(({ file }) => [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_41),
                  _createElementVNode("span", _hoisted_42, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (_ctx.handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_43),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (_ctx.handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_44))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.fileList.length < 3)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["on-change", "on-remove", "on-exceed", "file-list"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("img", {
            "w-full": "",
            src: _ctx.dialogImageUrl,
            alt: "Preview Image"
          }, null, 8, _hoisted_48)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.notificationDialogVisible,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.notificationDialogVisible) = $event)),
      title: "通知",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_button, {
            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.notificationDialogVisible = false))
          }, {
            default: _withCtx(() => _cache[54] || (_cache[54] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSendNotification
          }, {
            default: _withCtx(() => _cache[55] || (_cache[55] = [
              _createTextVNode("送信")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_form, { "label-width": "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "送信先",
                "label-width": "100px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.notificationForm.sendTo,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.notificationForm.sendTo) = $event)),
                    multiple: "",
                    filterable: "",
                    placeholder: "送信先を選択",
                    style: {"width":"100%"},
                    "max-collapse-tags": 5,
                    "collapse-tags-tooltip": "",
                    class: "notification-select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipientCandidates, (recipient) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: recipient.value,
                          label: recipient.label,
                          value: recipient.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("span", null, _toDisplayString(recipient.label), 1),
                              _createElementVNode("span", _hoisted_51, _toDisplayString(recipient.email), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "メッセージ",
                "label-width": "100px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.notificationForm.message,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.notificationForm.message) = $event)),
                    placeholder: "メッセージを選択",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.predefinedMessages, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "カスタムメッセージ",
                "label-width": "100px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.notificationForm.customMessage,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.notificationForm.customMessage) = $event)),
                    type: "textarea",
                    rows: "4",
                    placeholder: "カスタムメッセージを入力してください"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.statusDrawer,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.statusDrawer) = $event)),
      direction: "btt",
      size: "225px",
      "with-header": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.editStatusItem.status,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.editStatusItem.status) = $event)),
              placeholder: "ステータスを選択",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "未対応",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "補充依頼中",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "発注済み",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "廃棄予定",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "対応完了",
                  value: 5
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_el_button, {
              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.statusDrawer = false)),
              class: "cancel-btn"
            }, {
              default: _withCtx(() => _cache[56] || (_cache[56] = [
                _createTextVNode(" キャンセル ")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _ctx.handleStatusConfirm,
              class: "confirm-btn"
            }, {
              default: _withCtx(() => _cache[57] || (_cache[57] = [
                _createTextVNode(" 更新 ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}